import styles from "./LCatalogSingleColumn.module.css";

/**
 * LCatalogSingleColumn — catalog layout 1-kolumnowy.
 *
 * **Struktura (góra -> dół):**
 *   - catalogContent (BLOCKED, content z catalog management)
 *   - belowCatalog (window area)
 */
export function LCatalogSingleColumn({
  catalogContent,
  belowCatalog,
}: LCatalogSingleColumnProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>{catalogContent}</div>
      {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
    </div>
  );
}

export type LCatalogSingleColumnProps = {
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
};
